import React from 'react';
import BaseModal from '../BaseModal';
import { modalNames } from '../../../../shared/configs/modal';
import { lifeCycleEntitiesMap } from '../../constants';
import { useAcceptanceViewFlatsInvalidate } from '../../../../api/acceptanceViewFlats';
import { useChangeRoomStepMutation } from '../../../../api/changeRoomStep';
import SelectStep from '../SelectStep';

const ChangeStepModal = () => {
  const invalidateFlats = useAcceptanceViewFlatsInvalidate();

  const { mutateAsync, isLoading } = useChangeRoomStepMutation({
    onSuccess: () => {
      invalidateFlats();
    },
  });

  const getOnSubmit = ({ closeModal }) => {
    return async (values) => {
      await mutateAsync(values);
      closeModal();
    };
  };

  return (
    <BaseModal
      name={modalNames.changeRoomStep}
      getInitialValue={getInitialValue}
      getOnSubmit={getOnSubmit}
      entity={lifeCycleEntitiesMap.step}
      confirmLoading={isLoading}
    >
      <SelectStep />
    </BaseModal>
  );
};

export default ChangeStepModal;

function getInitialValue(room, lifeCycleState) {
  return typeof lifeCycleState === 'object'
    ? lifeCycleState?.step?.id
    : room?.stepAddressLifeCycle?.id;
}
